export const BONUSX_ACCESS_TOKEN = "bonusXAccessToken";

export const defaultApiConfig = {
  baseOptions: {
    withCredentials: true,
  },
  basePath: `${process.env.REACT_APP_MAIN_URL}/sapi/api/v1`,
  isJsonMime: () => false,
};

export const defaultApiConfig_v1_1 = {
  baseOptions: {
    withCredentials: true,
  },
  basePath: `${process.env.REACT_APP_MAIN_URL}/sapi/api/v1.1`,
  isJsonMime: () => false,
};

export const adminApiConfig = {
  baseOptions: {
    withCredentials: true,
  },
  basePath: `${process.env.REACT_APP_SADM_URL}/sadm/api/v1`,
  isJsonMime: () => false,
};

export const adminApiConfig_v1_1 = {
  baseOptions: {
    withCredentials: true,
  },
  basePath: `${process.env.REACT_APP_SADM_URL}/sadm/api/v1.1`,
  isJsonMime: () => false,
};

export const authApiConfig_v1 = {
  baseOptions: {
    withCredentials: true,
  },
  basePath: `${process.env.REACT_APP_AUTH_URL}/auth/api/v1`,
  isJsonMime: () => false,
};

export const defaultEventSourceConfig: EventSourceInit = {
  withCredentials: true,
};

export const ABILITY_RULES_KEY = "ability-rules";

export const ordinaryForms = ["citizenship", "family", "redditi", "patrimonio"];

export const ROOT_STORE_STORAGE_INDEX = "bonusXState";

export const USER_LOGIN_STORE_KEY = "bonusXUserLogin";

export const beforeUnloadEventName = "beforeunload";

export const BONUSX_WEBSITE_PATH = "https://bonusx.it";

type ExternalPathCollectionKeys =
  | "main"
  | "terms_of_use"
  | "general_conditions_of_service"
  | "privacy_policy"
  | "cookies_policy"
  | "contact_us"
  | "contact_email"
  | "ai_privacy_policy";

export const EXTERNAL_PATH_COLLECTION = new Map<ExternalPathCollectionKeys, string>([
  ["main", BONUSX_WEBSITE_PATH],
  ["terms_of_use", `${BONUSX_WEBSITE_PATH}/termini-di-utilizzo/`],
  ["general_conditions_of_service", `${BONUSX_WEBSITE_PATH}/condizioni-generali-di-servizio/`],
  ["privacy_policy", `${BONUSX_WEBSITE_PATH}/privacy-policy/`],
  ["cookies_policy", `${BONUSX_WEBSITE_PATH}/cookies-policy/`],
  ["contact_us", "https://bonusx.zendesk.com/hc/it"],
  ["contact_email", "mailto:supporto@bonusx.it"],
  ["ai_privacy_policy", `${BONUSX_WEBSITE_PATH}/privacy-policy-assistente-virtuale/`],
]);

export const DOM_READY_EVENT = "DOMContentLoaded";

export const ERROR_MATCH_4XX = /4[0-9]{2}/;
export const ERROR_MATCH_5XX = /5[0-9]{2}/;

export const APP_VERSION = process.env.REACT_APP_VERSION || "unknown";

// This is a fictitious page, utilized by the back button in the header in order to navigate back to the previous URL dynamically.
export const PREVIOUS_URL_PATH = "/prev-url";

export const EXTERNAL_LOGIN_PATH = "/external-login";

export const MOBILE_ONBOARDING_PATH = "/mobile-onboarding";

export const VERIFY_EMAIL_PATH = "/verify-email";

export const VERIFY_EMAIL_RELATIVE_PATH = "verify-email";

export const SURVEY_RELATIVE_PATH = "survey/:contextId/:surveyName/:step?";

export const DASHBOARD_PATH = "/dashboard";

export const PHONE_NUMBER_CONFIRMATION_PATH = "/phone-number-confirmation";

export const NOTIFICATIONS_PATH = "/notifications";

export const PROFILE_PATH = "/profile";

export const SERVICES_PATH = "/services";

export const SERVICES_BY_UID_PATH = "/services/by-uid";

export const REQUESTED_SERVICES_PATH = "/requested-services";

export const PRODUCT_REQUISITES_CONFIRMED_PATH = "/product-requisites/:productUniqueIdentifier/confirmed";

export const ARCHIVE_PATH = "/archive";

export const SETTINGS_PATH = "/settings";

export const INVITE_FRIENDS_PATH = "/invite-friends";

export const UPGRADE_PATH = "/upgrade";

export const LOGOUT_ROUTE = "/logout";

export const TOGGLE_BOTTOM_NAVIGATION_DRAWER_ROUTE = "/altro";

export const WELCOME_PATH = "/welcome";

export const LOGIN_PATH = "/login";

export const FORGOT_PASSWORD_PATH = "/forgot-password";

export const FORGOT_PASSWORD_EMAIL_SENT_PATH = "/forgot-password-email-sent";

export const CHOOSE_PASSWORD_PATH = "/choose-password/:token";

export const REGISTER_PATH = "/register";

export const EMAIL_VERIFICATION_SENT_PATH = "/email-verification-sent";

export const LOGIN_ERROR_SOCIAL_PATH = "/login/error/:social";

export const LOGGED_HOME_PAGE_PATH = "/profile";

export const PRICING_PAGE_PATH = "/pricing";

export const MIGRATE_PROFILE_PAGE_PATH = "/migrate-profile";

export const PROFILE_PERSONAL_DATA_VIEW_PATH = `${PROFILE_PATH}/personal-data`;

export const PROFILE_PERSONAL_DATA_EDIT_PATH = `${PROFILE_PATH}/personal-data/edit`;

export const PROFILE_ACTIVITY_DATA_VIEW_PATH = `${PROFILE_PATH}/activity-data`;

export const PROFILE_HOUSEHOLD_DATA_VIEW_PATH = `${PROFILE_PATH}/household`;

export const PROFILE_REAL_ESTATE_DATA_VIEW_PATH = `${PROFILE_PATH}/real_estate`;
export const PROFILE_REAL_ESTATE_DATA_EDIT_PATH = `${PROFILE_REAL_ESTATE_DATA_VIEW_PATH}/:realEstateId/edit`;

export const PROFILE_ISEE_DATA_VIEW_PATH = `${PROFILE_PATH}/isee`;

export const PROFILE_INCOME_DATA_VIEW_PATH = `${PROFILE_PATH}/incomes`;
export const PROFILE_INCOME_DATA_EDIT_PATH = `${PROFILE_INCOME_DATA_VIEW_PATH}/:incomeId/edit`;

export const PROFILE_HOUSEHOLD_MEMBER_DATA_CREATE_PATH = `${PROFILE_PATH}/household/members/create`;

export const PROFILE_HOUSEHOLD_MARITAL_STATUS_PATH = `${PROFILE_PATH}/household/marital-status`;

export const PROFILE_HOUSEHOLD_MEMBER_DATA_EDIT_PATH = `${PROFILE_PATH}/household/members/:memberId/edit`;
export const PROFILE_HOUSEHOLD_MEMBER_DATA_EDIT_PLACEHOLDER_PATH = `${PROFILE_PATH}/household/members/:memberId/edit-placeholder`;
export const PROFILE_HOUSEHOLD_MEMBER_PERSONAL_DATA_EDIT_PATH = `${PROFILE_PATH}/household/members/:memberId/edit/personal-data`;
export const PROFILE_HOUSEHOLD_MEMBER_RELATIONSHIP_EDIT_PATH = `${PROFILE_PATH}/household/members/:memberId/edit/relationship`;

export const ROUTES_WITH_MOBILE_APP_BANNER: (string | RegExp)[] = [
  LOGGED_HOME_PAGE_PATH,
  PROFILE_PATH,
  SERVICES_PATH,
  REQUESTED_SERVICES_PATH,
  ARCHIVE_PATH,
  SETTINGS_PATH,
  INVITE_FRIENDS_PATH,
  /^\/services\/\d+$/,
  /^\/requested-services\/\d+$/,
  /^\/requested-services\/\d+\/completed$/,
];

export const ADMIN_BASE_URL = "/admin";
export const ADMIN_PRODUCTS_PATH = `${ADMIN_BASE_URL}/services`;

export const GTM_ONCE_FOR_SESSION_KEY = "gtm_once_for_session";

export const BONUSX_VERIFY_EMAIL_COOKIE = "bonusXVerifyEmail";

export const BONUSX_ANNOUNCEMENT_MODAL_COOKIE = "bonusXHasSeenAnnouncementModal";

export const CLIENT_ID_PARAM_KEY = "ci";

export const MINLENGTH_TO_SEARCH = 2;

export const REACT_APP_SADM_URL = process.env.REACT_APP_SADM_URL;

export const REACT_APP_ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

export const REACT_APP_AUTH_URL = process.env.REACT_APP_AUTH_URL;

export const NODE_ENV = process.env.NODE_ENV;

export const BONUSX_CMS_URL = process.env.REACT_APP_CMS_URL;

export const BONUSX_CMS_TOKEN = process.env.REACT_APP_BONUSX_CMS_TOKEN || "";

export const GA_ID = process.env.REACT_APP_GA_ID || "";

export enum BonusXCustomResponseHeader {
  TotalCount = "x-total-count",
}

export const DEFAULT_DATE_LOCALE = "it";

export const DEFAULT_DATETIME_FORMAT = "DD/MM HH:mm";
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

export const ZENDESK_AUTH_PATH = process.env.REACT_APP_ZENDESK_AUTH_PATH;

const UPLOAD_SIZE_LIMIT = 18 * 1024 * 1024;

export const PICKER_DOCUMENT_UPLOAD_MAX_SIZE: number = UPLOAD_SIZE_LIMIT;

export const SIGNATURE_UPLOAD_MAX_SIZE: number = UPLOAD_SIZE_LIMIT;
export const CERTIFICATE_UPLOAD_MAX_SIZE: number = UPLOAD_SIZE_LIMIT;

export enum TrustpilotConfig {
  templateId = "53aa8807dec7e10d38f59f32",
  businessUnitId = "603e59a7cc01ad000135755e",
  locale = "it-IT",
  token = "d5612321-e80c-4a20-9c69-6a8d5c305f96",
}

export const DEFAULT_PAYMENT_METHOD = "creditcard";

export const FEATURE_FLAG_API_KEY = process.env.REACT_APP_FEATURE_FLAG_API_KEY ?? "";

export const MEILISEARCH_HOST = process.env.REACT_APP_MEILISEARCH_HOST ?? "";
export const MEILISEARCH_API_KEY = process.env.REACT_APP_MEILISEARCH_KEY ?? "";

export const BONUS_ON_DEMAND_SURVEY_LINK =
  process.env.BONUS_ON_DEMAND_SURVEY_LINK ?? "https://simplifai-ted.typeform.com/to/f0fkBBN0";
export const UNIQUE_IDENTIFIER_FIELD_NAME = "unique_identifier";
export const UNIQUE_IDENTIFIER_FIELD_DEFAULT_VALUE = "";
export const PRODUCT_MISSING_NAME_DEFAULT_VALUE = "Unavailable";

export const PACKAGE_NAME = "bx-feapp-platform";

export const ZERO_DIGIT = 0;

export const APP_COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
export const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const SEVEN_DAYS = 7;

export const SUBSCRIPTION_TIER_COMPARATOR_WEBSITE_URL_KEY = "SUBSCRIPTION_TIER_COMPARATOR_WEBSITE_URL";

export const DEFAULT_LOCALE = "it-IT";

export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN ?? "";

export const DEFAULT_LOCALE_OPTIONS = { minimumFractionDigits: 2 };

export const TRUE_VALUE_STRING = "true";

export const ELEVENLABS_AGENT_ID = process.env.REACT_APP_ELEVENLABS_AGENT_ID ?? "";

export const REDIRECT_TX_COOKIE_NAME = "bx_tx";
export const REDIRECT_PENDING_STORAGE_KEY = "next_url_pending_redirect";
export const REDIRECT_API_PATH = "/auth/api/v2/redirect";
export const REDIRECT_CONSUMED_SESSION_KEY = "next_url_consumed_redirect";
